export const VEHICLE_TYPE_EXPORT_ID = 'vehicle-type';

export const VEHICLE_TYPE_TITLE = 'Tipos de Vehículos';

export const LOCALIZED_PROPERTIES = {
  code: 'Codigo',
  name: 'Nombre',
  capacity: 'Capacidad',
  company: 'Compañia',
};
